import React from "react";
import "../styles/Testimonials.css";

// ✅ Impor gambar-gambar Anda di sini
import rinaldiAvatar from "../assets/rinaldi_palevi.jpg";
import syarifAvatar from "../assets/syarif_hidayatullah.jpg";
import ipungAvatar from "../assets/ipung.jpg";

const testimonialsData = [
    {
        name: "Rinaldi Pahlevi, Pemilik Depot Air Minum Anumta",
        text: "Sistem ini sangat membantu! Saya bisa tahu berapa banyak galon yang keluar tanpa harus ke lokasi, Jadi saya bisa urus pekerjaan saya yang lain yg juga menghasilkan.",
        avatar: rinaldiAvatar // ✅ Gunakan variabel yang diimpor
    },
    {
        name: "Syarif Hidayatullah, Distributor Air",
        text: "GPS tracking sangat membantu memastikan pengiriman air berjalan lancar.",
        avatar: syarifAvatar // ✅ Gunakan variabel yang diimpor
    },
    {
        name: "Ipung, Business Development Manager",
        text: "Saya merekomendasikan sistem air cerdas ini kepada pemilik depot air minum atau bahkan pengguna PDAM untuk pantau penggunaan aircnya secara mudah dan realtime.",
        avatar: ipungAvatar // ✅ Gunakan variabel yang diimpor
    }
];

const Testimonials = () => {
    return (
        <section className="testimonials-section">
            <h2>Apa Kata Pengguna?</h2>
            <div className="testimonials-grid">
                {testimonialsData.map((testimonial, index) => (
                    <div className="testimonial-card" key={index}>
                        {/* Pastikan `alt` text diisi dengan baik untuk SEO dan aksesibilitas */}
                        <img src={testimonial.avatar} alt={`Avatar ${testimonial.name}`} className="testimonial-avatar" />
                        <p>"{testimonial.text}"</p>
                        <p className="testimonial-name">— {testimonial.name}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;